module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"addItem":"Добавить тип обуви","name":"Название","position":"Позиция","create":"Создать","close":"Закрыть","status":{"default":"Выберите статус","active":"Активный","disable":"Выключена"}},"uk":{"addItem":"Додати тип взуття","name":"Назва","position":"Позиція","create":"Створити","close":"Закрити","status":{"default":"Виберіть статус","active":"Активний","disable":"Вимкнений"}}}')
  delete Component.options._Ctor
}
